var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "validation-observer",
    { ref: "findingCommentRef", attrs: { novalidate: "", tag: "form" } },
    [
      _c("div", { staticClass: "mx-4" }, [
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col-12" },
            [
              _c("validation-provider", {
                attrs: { rules: "required" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function({ errors }) {
                      return [
                        _c("div", { staticClass: "my-3" }, [
                          _c("em", {
                            staticClass: "fas fa-comment text-orange mr-1"
                          }),
                          _c("span", { staticClass: "pl-1" }, [
                            _vm._v("Comentario")
                          ])
                        ]),
                        _c("custom-text-area", {
                          attrs: {
                            "custom-error-msg":
                              "Es requerido documentar un comentario.",
                            error: errors[0],
                            maxlength: 2000,
                            "show-char-count": ""
                          },
                          model: {
                            value: _vm.comment,
                            callback: function($$v) {
                              _vm.comment = $$v
                            },
                            expression: "comment"
                          }
                        })
                      ]
                    }
                  }
                ])
              })
            ],
            1
          )
        ]),
        _c("div", { staticClass: "row mt-5 mt-md-0 mt-sm-3 pb-3 pt-3" }, [
          _c(
            "div",
            {
              staticClass:
                "col-12 d-flex align-items-center justify-content-md-end justify-content-sm-none"
            },
            [
              _c(
                "action-button",
                {
                  attrs: {
                    i: "fas fa-times-circle",
                    variant: "outline-danger btn-cancel danger px-3 mr-2"
                  },
                  on: {
                    click: function($event) {
                      return _vm.onCancel()
                    }
                  }
                },
                [_vm._v(" Cancelar ")]
              ),
              _c(
                "action-button",
                {
                  attrs: { i: "fas fa-save", variant: "success px-3" },
                  on: {
                    click: function($event) {
                      return _vm.onConfirm()
                    }
                  }
                },
                [_vm._v(" Guardar ")]
              )
            ],
            1
          )
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }